import React, { createContext, useContext, useState } from 'react';

interface HintContextType {
  freeHints: number;
  useFreeHint: (amount: number) => void;
  addFreeHint: () => void;
  addMultipleHints: (amount: number) => void;
}

const HintContext = createContext<HintContextType | undefined>(undefined);

export const HintProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [freeHints, setFreeHints] = useState(3); // Start with 3 free hints

  const useFreeHint = (amount: number) => {
    setFreeHints(prev => Math.max(0, prev - amount));
  };

  const addMultipleHints = (amount: number) => {
    setFreeHints(prev => prev + amount);
  };

  const addFreeHint = () => {
    addMultipleHints(1);
  };

  return (
    <HintContext.Provider value={{ freeHints, useFreeHint, addFreeHint, addMultipleHints }}>
      {children}
    </HintContext.Provider>
  );
};

export const useHintContext = () => {
  const context = useContext(HintContext);
  if (context === undefined) {
    throw new Error('useHintContext must be used within a HintProvider');
  }
  return context;
}; 